import * as React from 'react';

import type {NutshellMarketingStartTriggerFragment} from 'nutshell-graphql-types';

import {CLOSED_LEAD_DRIP_SEQUENCE_START_TRIGGERS} from '../../constants';

import {DripSequenceStartTriggerCard} from './drip-sequence-start-trigger-card';
import {SalesAutomationCard} from './sales-automation-card';

type Props = {
    parentId: string;
    startTrigger: NutshellMarketingStartTriggerFragment;
};

/*
 * Component that represents a single step template card on the sales process.
 */
export class ClosedLeadDripSequenceStartTriggerCard extends React.PureComponent<Props> {
    render() {
        const {startTrigger} = this.props;

        if (startTrigger.campaign.type !== 'DRIP_SEQUENCE') {
            // We only allow start triggers on drip sequences, so this is very
            // confusing if this ever runs
            return null;
        }

        return (
            <SalesAutomationCard
                parentId={this.props.parentId}
                type={CLOSED_LEAD_DRIP_SEQUENCE_START_TRIGGERS}
                isHidden={false} // Can't drag cards or outcomes around no hidden state
                entityId={startTrigger.campaign.id}
            >
                <DripSequenceStartTriggerCard startTrigger={startTrigger} />
            </SalesAutomationCard>
        );
    }
}
